/**
 * The numeric value for the locale on the backend. This should only be used to map values to a Locale value.
 */
enum LocaleNumber {
    en = 0,
    es = 1,
    fr = 2
}

export { LocaleNumber };
